const compare = (a, b) => (a > b) - (a < b);

export {
    compare
}